import React, { useEffect, useState } from 'react';
import ReactSelect from 'react-select';
import { MODE_CREATE_FORM, MODE_HIDE_TILE, MODE_SHOW_ALERT } from "./Index";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { setNestedObjectValues } from 'formik';



const SearchGroup = ({ formik, businessList, modeShow, mode, setMode, bu, setBu, setModeShow, filterBTN, setFilterBTN }) => {

    const [storageItem, setStorageItem] = useState("")

    const location = useLocation();

    useEffect(() => {
         
        const searchDetailsId = parseInt(localStorage.getItem("searchDetails"));
        setStorageItem(businessList?.find(it => it.value === searchDetailsId)?.label)
    }, [businessList , localStorage.getItem("searchDetails")])


/*     const filterData = () => {
         
        localStorage.removeItem("searchDetails");
        setFilterBTN(false)
    }
 */

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="row mb-4">

                <div className='col-md-3 thisHide' style={{ position: "relative", zIndex: "10" }}>
                    <label>  انتخاب کسب و کار     </label>
                    <ReactSelect
                        placeholder={storageItem ? storageItem : "انتخاب کنید"}
                        options={businessList.filter(item => item.isActive === true)}
                        name="buisnessId"
                        isSearchable={true}
                        value={formik.values.buisnessId}
                        onChange={value => formik.setFieldValue("buisnessId", value)}
                        noOptionsMessage={() => 'نام مورد نظر یافت نشد'}
                    />
                </div>

                <div className='col-md-3 mt-4 pt-3'>
                    <button className="btn btn-success">نمایش اطلاعات</button>
               {/*      {filterBTN && <button type='reset' className="btn btn-danger mx-2"
                        onClick={() => {
                            formik.setFieldValue('buisnessId', ' ');
                            filterData();
                        }
                        }>حذف اطلاعات</button>} */}

                </div>

            </div>
        </form >
    );
}

export default SearchGroup;